import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { Post, Template } from "../../interface/transactional/transactional";
import { MessagingService } from "../../messaging.service";
@Component({
  selector: "messaging-dynamic-variables",
  templateUrl: "./dynamic-variables.component.html",
  styleUrls: ["./dynamic-variables.component.scss"],
})
export class DynamicVariablesComponent implements OnInit, OnChanges {
  @Input() predefinedVariables: any[] = [];
  @Input() selectedTemplate: Template = null;
  @Input() isValidFormSubmitted: boolean = true;
  @Input() isFromSettings: boolean = false;
  @Input() feature: "interact" | "messaging" = "messaging";
  @Input() hideHeading: boolean = false;
  @Input()
  set content(content: string) {
    this._content = content;
  }
  get content(): string {
    return this._content;
  }
  dynamicVariables: any = {};
  private _content: string = "";
  objectKeys = Object.keys;
  constructor(private messagingService: MessagingService) {}

  ngOnDestroy() {}

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    if (
      changes.content &&
      changes.content.currentValue !== undefined &&
      changes.content.currentValue !== null
    ) {
      let content = changes.content.currentValue;
      this.content = content;
      this.setDynamicVariables(content);
    }
    if (
      changes.selectedTemplate &&
      changes.selectedTemplate.currentValue !== undefined &&
      changes.selectedTemplate.currentValue !== null
    ) {
      let selectedTemplate = changes.selectedTemplate.currentValue;
      this.content = selectedTemplate?.content || "";
      this.setDynamicVariables(this.content);
    }
  }
  ngOnInit() {
    this.messagingService.resetFields$.subscribe((reset) => {
      if (reset) {
        this.emptyDynamicVariable();
      }
    });
    this.messagingService.editPost$.subscribe((post) => {
      if (post) {
        this.setDynamicVariables(this.content, post.dynamic_variables);
      }
    });
    this.messagingService.contentChange$.subscribe((content) => {
      if (content) {
        // hidden for testing purposes - problem resetting payload
        // this.setDynamicVariables(content);
      }
    });
  }

  public updatePreview($event = null) {
    this.messagingService.updateDynamicVariable($event);
  }

  placeholderText = (variable: { value: { isEditable: any; label: any } }) => {
    return variable?.value?.isEditable
      ? `Enter Value for ${variable?.value?.label}`
      : `${variable?.value?.label} - Cannot Edit`;
  };

  private previewDynamicValue(variable: string) {
    let variableValue = this.dynamicVariables[variable]["value"];
    return variableValue || variable;
  }
  public getPreviewContent() {
    const content: string = this.content;
    const curlyBracesReg = /{{(.*?)}}/gi;
    let dynamicVariablesMatch: string[] = content.match(curlyBracesReg) || [];
    let { trimmedVariables, newPreviewContent } = this.getTrimmedVariables(
      dynamicVariablesMatch,
      content
    );
    trimmedVariables.forEach((variable) => {
      newPreviewContent = newPreviewContent.replace(
        variable,
        this.previewDynamicValue(variable)
      );
    });
    return {
      content: newPreviewContent,
    };
  }

  private getTrimmedVariables(
    dynamicVariablesMatch: string[],
    previewContent: string = null
  ) {
    const curlyBracesTextReg = /{{(.*?)}}/;
    let newPreviewContent: string = previewContent;
    let trimmedVariables = dynamicVariablesMatch.map((variable) => {
      let newVariable = variable.match(curlyBracesTextReg)[1];
      let trimmedLabel = `{{${newVariable.trim()}}}`;
      if (newPreviewContent !== null) {
        newPreviewContent = newPreviewContent.replace(variable, trimmedLabel);
      }
      return trimmedLabel;
    });
    return { trimmedVariables, newPreviewContent };
  }
  private getPredefinedVariable(label: string): {
    value: string;
    isEditable: boolean;
  } {
    let predefinedVariable = this.predefinedVariables.find(
      (e) => e.label == label
    );

    return {
      value: predefinedVariable?.value || "",
      isEditable:
        predefinedVariable !== undefined
          ? predefinedVariable?.is_editable
          : true,
    };
  }
  private postVariable(
    label: string,
    postDynamicVariables: Post["dynamic_variables"]
  ) {
    let postVariable = postDynamicVariables?.find(
      (e) => e.variable_name == label
    );
    return postVariable;
  }
  private getPostVariable(
    label: string,
    postDynamicVariables: Post["dynamic_variables"]
  ): { value: string; isEditable: true } {
    let postVariable = this.postVariable(label, postDynamicVariables);
    return {
      value: postVariable?.variable_value || "",
      isEditable: postVariable?.is_editable || true,
    };
  }
  private templateVariable(label: string) {
    if (this.selectedTemplate !== null) {
      let templateVariable = this.selectedTemplate?.dynamic_variables?.find(
        (e) => {
          return e.variable_name == label;
        }
      );
      return templateVariable;
    }
  }
  private isTemplateVariable(label: string) {
    return this.templateVariable(label);
  }
  private templateVariableArrayLength() {
    let templateVariable: any[] = this.selectedTemplate?.dynamic_variables;
    return templateVariable?.length;
  }
  private getTemplateVariable(label: string): {
    value: string;
    isEditable: boolean;
  } {
    let templateVariable = this.templateVariable(label);
    return {
      value: templateVariable?.variable_value || "",
      isEditable: templateVariable?.is_editable || true,
    };
  }
  public setDynamicVariables(
    contentValue: string,
    postDynamicVariables: Post["dynamic_variables"] | null = null
  ) {
    const curlyBracesReg = /{{(.*?)}}/gi;
    let dynamicVariablesMatch: string[] =
      contentValue.match(curlyBracesReg) || [];
    let { trimmedVariables } = this.getTrimmedVariables(dynamicVariablesMatch);
    if (trimmedVariables.length) {
      let dynamicVariables = trimmedVariables.reduce((variables, label) => {
        let dynamicObj = this.dynamicVariables[label];
        if (dynamicObj) {
          var [value, isEditable]: [string, boolean] = [
            dynamicObj["value"],
            dynamicObj["isEditable"],
          ];
        } else {
          var { value, isEditable } = this.getPredefinedVariable(label);
        }
        if (this.isTemplateVariable(label) !== undefined) {
          var { value } = this.getTemplateVariable(label);
        }
        if (postDynamicVariables !== null) {
          var { value } = this.getPostVariable(label, postDynamicVariables);
        }

        return {
          ...variables,
          [label]: {
            label,
            value,
            isEditable,
          },
        };
      }, {});
      this.dynamicVariables = { ...dynamicVariables };
    } else {
      this.emptyDynamicVariable();
    }
  }
  emptyDynamicVariable() {
    this.content = "";
    this.dynamicVariables = {};
  }
  private filterVariables(isPayload: boolean) {
    const curlyBracesTextReg = /{{(.*?)}}/;
    let dynamicVariables = {};
    let label: string;
    for (const key in this.dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(this.dynamicVariables, key)) {
        const variable = this.dynamicVariables[key];
        if (isPayload) {
          label = variable["label"].match(curlyBracesTextReg)[1];
        } else {
          label = variable["label"];
        }
        let value: string = variable["value"];
        if (label && value) {
          dynamicVariables[label] = value.trim();
        }
      }
    }
    return dynamicVariables;
  }
  createDynamicVariablePayload() {
    let dynamicVariables = this.filterVariables(true);
    return { dynamic_variables: dynamicVariables };
  }
  isInValidDynamicVariable() {
    let isInvalid = false;
    for (const key in this.dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(this.dynamicVariables, key)) {
        const variable = this.dynamicVariables[key];
        if (variable["value"] == "" && variable["isEditable"]) {
          isInvalid = true;
        }
      }
    }
    return isInvalid;
  }
  private isVariableChanged(dynamicVariables: { [x: string]: any }) {
    let isUpdate = false;
    console.log(dynamicVariables);
    for (const key in dynamicVariables) {
      if (Object.prototype.hasOwnProperty.call(dynamicVariables, key)) {
        const label = key;
        const variableValue = dynamicVariables[key];
        let isTemplateVariable = this.isTemplateVariable(label) !== undefined;
        if (isTemplateVariable) {
          var { value } = this.getTemplateVariable(label);
          console.log(variableValue, value);
          if (variableValue !== value) {
            isUpdate = true;
          }
        }
      }
    }
    return isUpdate;
  }
  isUpdateDynamicVariable() {
    let isUpdate = false;
    let dynamicVariables = this.filterVariables(false);
    if (this.selectedTemplate !== null) {
      if (
        this.templateVariableArrayLength() !==
          this.objectKeys(dynamicVariables).length ||
        this.isVariableChanged(dynamicVariables)
      ) {
        isUpdate = true;
      }
    }
    return isUpdate;
  }
  // private getPredefinedVariables() {
  //   this.messagingService.getPredefiledVariablesAPI().subscribe((res) => {
  //     console.log(res);
  //     if (res.code == 200) {
  //       let predefinedVariables: Array<any> = res.data;
  //       this.predefinedVariables = predefinedVariables;
  //       this.initialised = true;
  //     }
  //   });
  // }
}
